if (document.getElementById('read-more')) {
    let ReadMore = import('../Components/Vanilla/ReadMore');
}

if(document.getElementById("cookie-consent-banner")) {
    let CookieConsent = import("../Components/Vanilla/CookieConsent")
}

if(document.getElementById("age-consent-banner")) {
    let AgeConsent = import("../Components/Vanilla/AgeConsent")
}
if(document.querySelectorAll(".quantity-purchase-container__listing").length > 0) {
    import("../Components/Vanilla/BuyQuantityToggle")
}